import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../components/shared/utility';

const initialState = {
    files: [],
    allowedFiles: "",
    error: null
};

const onClaimsAttachmentConfigSuccess = (state, action) => {
    return updateObject(state, {
        allowedFiles: action.config
    })
};

const onClaimsAttachmentConfigFailure = (state, action) => {
    return updateObject(state, {
        error: action.error
    })
};

const onAttachmentDeleteSuccess = (state, action) => {
    return updateObject(state, {
        files: state.files.filter(el => el.fileName !== action.fileName)
    })
};

const onAttachmentDeleteFailure = (state, action) => {
    return updateObject(state, {
        error: action.error
    })
};

const onAttachmentUpload = (state, action) => {
    const {files} = state;

    const uploadedAcceptedFiles = files.concat(action.files);

    return updateObject(state, {
        files: uploadedAcceptedFiles
    })
};

const reducer = (state = initialState, action) =>{
    switch (action.type){
        case actionTypes.FETCH_CLAIMS_ATTACHMENT_CONFIG_SUCCESS:
            return onClaimsAttachmentConfigSuccess(state, action);
        case actionTypes.FETCH_CLAIMS_ATTACHMENT_CONFIG_FAILURE:
            return onClaimsAttachmentConfigFailure(state, action);
        case actionTypes.ATTACHMENT_UPLOAD_SUCCESS:
            return onAttachmentUpload(state, action);
        case actionTypes.ATTACHMENT_DELETE_SUCCESS:
            return onAttachmentDeleteSuccess(state, action);
        case actionTypes.ATTACHMENT_DELETE_FAILURE:
            return onAttachmentDeleteFailure(state, action);
        default:
            return state
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/attachmentReducer.js